module.exports = __webpack_public_path__ + "img/new-object-bag.a35c0250.png";